<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M7,1.8601171875C6.72,1.8601171875,6.47,1.9701171875,6.29,2.1501171875000002C6.29,2.1501171875000002,3.59,4.8601171875,3.59,4.8601171875C3.59,4.8601171875,1,4.8601171875,1,4.8601171875C0.45,4.8601171875,0,5.3101171875,0,5.8601171875C0,5.8601171875,0,9.8601171875,0,9.8601171875C0,10.4101171875,0.45,10.8601171875,1,10.8601171875C1,10.8601171875,3.59,10.8601171875,3.59,10.8601171875C3.59,10.8601171875,6.3,13.5701171875,6.3,13.5701171875C6.48,13.7501171875,6.73,13.8601171875,7.01,13.8601171875C7.56,13.8601171875,8.01,13.4101171875,8.01,12.8601171875C8.01,12.8601171875,8.01,2.8601171875,8.01,2.8601171875C8,2.3101171875,7.55,1.8601171875,7,1.8601171875C7,1.8601171875,7,1.8601171875,7,1.8601171875ZM13.74,0.8701171875C13.74,0.8701171875,12.16,2.0901171874999998,12.16,2.0901171874999998C13.31,3.7201171875,14,5.7101171875,14,7.8601171875C14,10.0201171875,13.31,12.0101171875,12.15,13.6401171875C12.15,13.6401171875,13.73,14.8601171875,13.73,14.8601171875C15.15,12.8901171875,15.99,10.4801171875,15.99,7.8601171875C16,5.2501171875,15.15,2.8401171874999998,13.74,0.8701171875C13.74,0.8701171875,13.74,0.8701171875,13.74,0.8701171875ZM8.98,4.5201171875C9.62,5.4801171875,10,6.6301171875,10,7.8601171875C10,9.0901171875,9.62,10.2501171875,8.98,11.2001171875C8.98,11.2001171875,10.57,12.4201171875,10.57,12.4201171875C11.47,11.1301171875,12,9.5601171875,12,7.8601171875C12,6.1601171875,11.47,4.590117187500001,10.57,3.3001171875C10.57,3.3001171875,8.98,4.5201171875,8.98,4.5201171875C8.98,4.5201171875,8.98,4.5201171875,8.98,4.5201171875Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'VolumeUp',
} as DefineComponent
</script>
